import {
  Button,
  Collapse,
  ControlGroup,
  InputGroup,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, niceDateTime } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";

class EntityComments extends React.Component {
  state = {
    loadedComments: [],
    enteredComment: "",
    commentsExpanded: false,
    addingComment: false,
    loadingComments: false,
    hasLoadedComments: false,
  };

  getComments = async () => {
    try {
      this.setState({ loadingComments: true });
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/comment/getByAssociatedEntity`,
        {
          associatedEntityId: this.props.data._id,
        }
      );

      this.setState({
        commentsExpanded: true,
        loadedComments: res,
        hasLoadedComments: true,
      });
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading comments. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ loadingComments: false });
    }
    return;
  };
  renderCommentsCard = () => {
    return (
      <>
        {" "}
        <ControlGroup>
          <Tag
            large
            minimal
            interactive
            icon="chat"
            onClick={() => {
              if (this.state.hasLoadedComments) {
                this.setState({
                  commentsExpanded: !this.state.commentsExpanded,
                });
              } else {
                this.getComments();
              }
            }}
          >
            {this.props.isTable ? null : (
              <>
                {" "}
                {!this.state.hasLoadedComments
                  ? "Load Comments"
                  : this.state.commentsExpanded
                  ? `${this.state.loadedComments.length} ${
                      this.state.loadedComments.length === 1
                        ? "Comment"
                        : "Comments"
                    } `
                  : `View ${this.state.loadedComments.length} ${
                      this.state.loadedComments.length === 1
                        ? "Comment"
                        : "Comments"
                    }`}
              </>
            )}
          </Tag>
          {this.state.loadingComments ? <Spinner size={20} /> : ""}
        </ControlGroup>
        <Collapse isOpen={this.state.commentsExpanded}>
          {this.renderComments()}
          <ControlGroup style={{ marginTop: "10px" }}>
            <InputGroup
              disabled={this.state.addingComment}
              fill
              value={this.state.enteredComment}
              onChange={(event) =>
                this.setState({ enteredComment: event.target.value })
              }
            />
            <Button
              icon="chat"
              loading={this.state.addingComment}
              text="Add New Comment"
              onClick={() => this.addComment()}
            />
          </ControlGroup>
        </Collapse>
      </>
    );
  };
  renderComments = () => {
    let x = this.state.loadedComments;
    if (!x.length) {
      return (
        <ControlGroup>
          <Tag minimal large>
            No comments added. Start the discussion by adding a comment below.
          </Tag>
        </ControlGroup>
      );
    }
    return x.map((each) => {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large intent="success">
            {each.createdByName}
          </Tag>
          <Tag minimal large intent="warning">
            {niceDateTime(each.createdAt)}
          </Tag>{" "}
          <Tag multiline intent="primary">
            {each.commentText}
          </Tag>
        </ControlGroup>
      );
    });
  };
  addComment = async () => {
    try {
      cogoToast.loading(`Adding new comment`);
      this.setState({ addingComment: true });
      await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/comment/createNew`,
        {
          commentText: this.state.enteredComment,
          associatedEntityId: this.props.data._id,
        }
      );
      cogoToast.success(`Done.`);
      this.setState({ enteredComment: "" }, () => this.getComments());
    } catch (err) {
      cogoToast.error(
        `We ran into an error while adding a new comment. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ addingComment: false });
    }
    return;
  };
  render() {
    return (
      <div style={{ marginTop: `${this.props.isTable ? "" : "10px"}` }}>
        {this.renderCommentsCard()}
      </div>
    );
  }
}

export default inject("authStore")(observer(EntityComments));
